import React from 'react';
import { Link } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import { LantisPageCounterBlModel } from '../../../../Restful/LantisApi';
import useUpdatePageCount from '../../../core/hooks/useUpdatePageCount';

type MosaicLinkProps = {
    mosaicItem: LantisPageCounterBlModel;
    toggleDialog: any;
    className?: string;
};

const MosaicLink: React.FC<MosaicLinkProps> = ({ mosaicItem, children, toggleDialog, ...other }) => {
    const { updateMutation } = useUpdatePageCount();
    const handelOnClickExternalTile = () => {
        updateMutation.mutate({LantisPageId : mosaicItem.id});
    };
  
    return (
        <>
            {mosaicItem.isExternalLink ? (
                mosaicItem.warningText ? (
                    <div onClick={handelOnClickExternalTile}>
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={mosaicItem.link!}
                        {...other}
                        onClick={toggleDialog}
                    >
                        {children}
                    </a>
                    </div>
                ) : (
                    <div onClick={handelOnClickExternalTile}>
                    <a target="_blank" rel="noopener noreferrer" href={mosaicItem.link!} {...other}>
                        {children}
                    </a>
                    </div>
                )
            ) : (
                <Link component={RouterLink} to={mosaicItem.link!} {...other}>
                    {children}
                </Link>
            )}
        </>
    );
};

export default MosaicLink;
